import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { MessageLoaderProps } from '../../types';

export const MessageLoader = ({ classname, width }: MessageLoaderProps) => {
  return (
    <div className={classname}>
      <CatSkeleton size="sm" width={width} />
    </div>
  );
};

export default MessageLoader;
